/**
 * Store Locations — Prev/Next scroll navigation + mobile progress bar
 */
(function () {
  'use strict';

  var scrollContainer = document.getElementById('store-locations-scroll');
  var prevBtn = document.querySelector('.store-nav-prev');
  var nextBtn = document.querySelector('.store-nav-next');
  var progressBar = document.getElementById('store-locations-progress');

  if (!scrollContainer) return;

  function scrollNav(dir) {
    var card = scrollContainer.querySelector('.snap-start');
    var amount = card ? card.offsetWidth + 16 : 400;
    scrollContainer.scrollBy({ left: dir === 'left' ? -amount : amount, behavior: 'smooth' });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () { scrollNav('left'); });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () { scrollNav('right'); });
  }

  // Progress bar
  function updateProgress() {
    if (!progressBar) return;
    var max = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    var pct = max > 0 ? (scrollContainer.scrollLeft / max) * 100 : 0;
    progressBar.style.width = Math.max(20, pct) + '%';
  }

  var ticking = false;
  scrollContainer.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        updateProgress();
        ticking = false;
      });
    }
  }, { passive: true });

  updateProgress();
})();
